/// <amd-module name="Wiki/ProjectOverview/WikiLegacyHelper" />
import { WikiPage } from "Wiki/Clients/Wiki/Contracts/Wiki";
import * as Resources from "Wiki/ProjectOverview/Resources";

// this file is heavily copied from old web platform wiki helper methods.
// needed for rendering wiki home page on project overview.
// todo: remove this once wiki moves to new web platform

export function flattenWikiPage(page: WikiPage): WikiPage[] {
    if (!page) {
        return [];
    }

    const pages: WikiPage[] = [];
    let unprocessedPages: WikiPage[] = [page];

    while (unprocessedPages.length > 0) {
        const tempPages: WikiPage[] = [];

        for (var unprocessedPage of unprocessedPages) {
            pages.push(unprocessedPage);
            tempPages.push(...unprocessedPage.subPages);
        }

        unprocessedPages = [];
        unprocessedPages.push(...tempPages);
    }

    return pages;
}

export class WikiErrorNames {
    public static gitItemNotFoundException = "GitItemNotFoundException";
    public static wikiPageNotFoundException = "WikiPageNotFoundException";
}

export namespace RepoConstants {
    export const RootPath = "/";
}

export function getWikiReadError(error: any, pagePath: string): Error | undefined {
    const tfsError: any = error; // todo fix the tfs part
    if (!tfsError || !tfsError.serverError) {
        return tfsError;
    }

    let errorMessage: string | undefined;
    const errorName: string = tfsError.serverError.typeKey;
    switch (tfsError.serverError.typeKey) {
        case WikiErrorNames.gitItemNotFoundException:
        case WikiErrorNames.wikiPageNotFoundException:
            errorMessage = Resources.WikiErrorTitle;
            break;
        default:
            break;
    }

    return errorMessage ? getError(errorName, errorMessage) : undefined;
}

function getError(errorName: string, errorMessage: string): Error {
    const newError: Error = new Error(errorMessage);
    newError.name = errorName;

    return newError;
}

export function isWikiHomePage(page: WikiPage): boolean {
    if (page && page.order === 0 && !page.isNonConformant && page.path !== RepoConstants.RootPath) {
        return true;
    }

    return false;
}
